import { Stack, StackProps, styled } from '@mui/material';

export const SettingsMenuRow = styled(Stack)<StackProps>(({ theme }) => ({
  padding: theme.spacing(2),
  justifyContent: 'space-between',
  fontSize: '0.875',
  fontWeight: 400,
  lineHeight: '142%',
  width: '100%',
  alignItems: 'center',
  flexDirection: 'row',
}));
